import { QueryKey, queryOptions } from '@tanstack/react-query'

import { STATION_QUERY_KEYS } from './keys'
import { GetStationPayload } from './types'
import { getStation } from './services'

export const createStationQueryOptions = (params: GetStationPayload) => {
  const queryKey: QueryKey = [STATION_QUERY_KEYS.GET_STATION, params]
  const queryFn = () => getStation(params)

  return queryOptions({
    queryKey,
    queryFn,
  })
}
